import {
  Grid as MuiGrid,
  Chip as MuiChip,
  Typography as MuiTypography,
} from "@mui/material";
import { Engineering as MuiEngineering } from "@mui/icons-material";
import InfoCard from "./InfoCard";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const HonestBrokerCard = ({ honestBrokerStatus }) => {
  const { t } = useTranslation();
  return (
    <InfoCard
      iconComponent={MuiEngineering}
      title={t("studyInsights.honestBrokerService")}
      titleVariant="small"
      helpText={
        "The Honest Broker Card provides a quick overview of the Participant Engagement Service status for your study."
      }
    >
      <MuiGrid container spacing={1} alignItems="center" sx={{ width: "100%" }}>
        <MuiGrid size={{ xs: 12, md: 6 }}>
          <MuiTypography>Participant Engagement Service:</MuiTypography>
        </MuiGrid>
        <MuiGrid
          size={{ xs: 12, md: 6 }}
          sx={{ marginLeft: "auto", textAlign: "right" }}
        >
          {honestBrokerStatus === "ASSIGNED" ? (
            <MuiChip label="Enabled" color="success" />
          ) : (
            <MuiChip label="Disabled" color="warning" />
          )}
        </MuiGrid>
      </MuiGrid>
    </InfoCard>
  );
};

HonestBrokerCard.propTypes = {
  honestBrokerStatus: PropTypes.string.isRequired,
};

export default HonestBrokerCard;
